import React from 'react'
import ReactLoading from 'react-loading';

export function LoadingSpin({ height = 32, width = 32, className }) {
  return (
    <ReactLoading type={'spin'} color="#606bc8" height={height} width={width} className={className} />
  )
}
